export enum Direction {
    None = 0,
    Asc = 1,
    Desc = 2,
}